import { render, staticRenderFns } from "./ServiceQuestionSingle.vue?vue&type=template&id=28dc4ee6"
import script from "./ServiceQuestionSingle.vue?vue&type=script&lang=js"
export * from "./ServiceQuestionSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports